
// this file is automatically generated by git.version.ts script
export const versions = {
  revision: '89ae9fbe4dcb7b1ad797f8aa6c85e829406b48b5',
  branch: 'HEAD',
};



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!../config/environments/versions.ts